import { Component, OnInit } from '@angular/core';
import { AppStateService, IStateQueryParams } from '../core/app-state.service';
import { WebTrekkService } from '../core/web-trekk.service';

@Component({
    selector: 'welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent implements OnInit {
    public backgroundUrl: string = require("./img/background.jpg");

    constructor(
        private appState: AppStateService,
        private tracker: WebTrekkService,
    ) {}

    public ngOnInit() {
        this.tracker.trackEvent('startpage');
        this.appState.setMobilePulldown(true);
    }

    public getConfigureQueryParams(): IStateQueryParams {
        const baseState: IStateQueryParams = this.appState.urlQueryParamsBaseMap();
        baseState.s = 0;

        return baseState;
    }

    public getMobileQueryParams(): IStateQueryParams {
        return this.appState.urlQueryParamsBaseMap();
    }
}


// WEBPACK FOOTER //
// ./src/app/welcome/welcome.component.ts